import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)

  return (
    data?.map((item: any, index: any) => {
      return {
        approvalStatus: item?.approvalStatus,
        approvalType: item?.approvalType,
        className: item?.className,
        id: item?.id,
        key: item?.key,
        type: item?.type,
        username: item?.username,
        data: {
          type: 'package2MId',
          id: item?.object?.id,
          mid: item?.object?.mid,
          packageName: item?.object?.packageName,
        },
      }
    }) ?? []
  )
}

const getPackageToMIdPendingApprovals = (elevated: boolean, tokens: any, fileType: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingMid2PackPendingApprovals),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
      fileType
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getPackageToMIdPendingApprovals }
